// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR_OF_username = "Baz\u00e1r pou\u017e\u00edvate\u013eky %(username)s";
export const BAZAAR_SEO_BABY = "Baz\u00e1r";
export const CONFIRM = "Potvr\u010f";
